import { render } from "./StocksListing.vue?vue&type=template&id=a6bf585c&ts=true"
import script from "./StocksListing.vue?vue&type=script&lang=ts"
export * from "./StocksListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__